/**
 *
 * PasswordInput
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import IconButton from 'components/interaction/IconButton/index.jsx';
import { PASSWORDLENGTH } from './constants.js';

const InputGroup = styled.div`
  position: relative;
  input {
    font-family: ${(p) => p.theme.fontFamilyMonospace};
      &::placeholder,
      &.input-placeholder {
        font-family: ${(p) => p.theme.fontFamilyBase};
      }
    }
`;

const Inside = styled.span`
  position: absolute;
  ${(p) => p.align}: 0;
    right: 0;
  span {
    color: ${(p) => p.theme.brandDanger}
  }
  button {
    /* color: ${(p) => p.theme.btnDefaultBorder} */
  }
`;

function PasswordInput(props) { // eslint-disable-line react/prefer-stateless-function
  const {
    id, value = '', onChange, message, horizontal, hint, visible, setVisible, showLength, minLength = PASSWORDLENGTH, ...rest
  } = props;
  const { length } = value;
  const showControls = setVisible || showLength;
  delete rest.as;
  const className = horizontal ? 'd-sm-flex align-items-baseline mb-3' : '';
  const labelStyle = horizontal ? { width: '8rem' } : {};
  const iconClass = classNames(['text-secondary fs-3 lower-1', visible ? 'ss-eye-open' : 'ss-eye-close']);
  return (
    <InputGroup controlId={id} className={className}>
      {hint && (
        <div className="float-end"><a href={hint.url} target="_blank">{hint.text}</a></div>
      )}
      <Form.Label style={labelStyle} htmlFor={id} className="pe-4 text-sm-end"><FormattedMessage {...message} /></Form.Label>
      <div className="position-relative w-100">
        <Form.Control
          className="form-control"
          {...rest}
          name={id}
          id={id}
          onChange={onChange}
          value={value}
          type={visible ? 'text' : 'password'}
          required
        />
        {showControls && (
          <Inside align={horizontal ? 'top' : 'bottom'}>
            {showLength && length > 0 && length < minLength && (
              <span>
                {length}
                /
                {minLength}
              </span>
            )}
            {setVisible
            && <IconButton icon={iconClass} variant="link" onClick={() => setVisible(!visible)} />}
          </Inside>
        )}
      </div>
    </InputGroup>
  );
}

PasswordInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  message: PropTypes.object,
  horizontal: PropTypes.bool,
  hint: PropTypes.object,
  visible: PropTypes.bool,
  minLength: PropTypes.number,
  showLength: PropTypes.bool,
  setVisible: PropTypes.func,
};

export default PasswordInput;
